import { GCInstant } from '../gcinstant';

export function trackFirstButtonTap(opts: {
  feature: string;
  $subFeature: string;
}) {
  GCInstant.trackFirstButtonTap(opts);
}
